/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-16 10:27:36
 */
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

/*-----------分组管理----------*/
// 判断是否可以删除
export const isDelGroup = (params: any) => {
	return https().request('group/canDeleteGroup', Method.GET, params, ContentType.form)
}
// 分组列表
export const groupList = (params: any) => {
	return https().request('group/groupList', Method.POST, params, ContentType.json)
}
// 机器人列表
export const groupRobotList = (params: any) => {
	return https().request('group/robotList', Method.GET, params, ContentType.form)
}
// 添加分组
export const addGroup = (params: any) => {
	return https().request('group/addGroup', Method.POST, params, ContentType.json)
}
// 修改分组
export const updateGroup = (params: any) => {
	return https().request('group/updateName', Method.GET, params, ContentType.form)
}
// 删除分组
export const deleteGroup = (params: any) => {
	return https().request('group/deleteGroup', Method.GET, params, ContentType.form)
}
// 删除机器人
export const deleteRobot = (params: any) => {
	return https().request('group/deleteRobot', Method.POST, params, ContentType.json)
}
// 查询未分组的机器人
export const robotGroupList = (params: any) => {
	return https().request('group/robotGroupList', Method.POST, params, ContentType.json)
}
// 添加机器人
export const addRobot = (params: any) => {
	return https().request('group/addRobot', Method.POST, params, ContentType.json)
}
// 机器人位置信息
export const robotInfo = (params: any) => {
	return https().request('group/moveInfo', Method.GET, params, ContentType.form)
}
// 移动机器人
export const moveRobot = (params: any) => {
	return https().request('group/moveRobot', Method.POST, params, ContentType.json)
}
// 获取厂商列表
export const getForproducers = (params: any) => {
	return https().request('robohub/companyList?page=1&pageSize=100', Method.GET, params, ContentType.json)
}
// 新增厂商
export const companysAdd = (params: any) => {
	return https().request('robohub/companyAdd', Method.POST, params, ContentType.json)
}
// 删除厂商
export const deletecompanys = (params: any) => {
	return https().request(`robohub/deleteCompany?id=${params.id}&updateBy=${params.updateby}`, Method.GET, params, ContentType.json)
}
// 修改厂商
export const updateCompanys = (params: any) => {
	return https().request(`robohub/updateCompany`, Method.POST, params, ContentType.json)
}
// 获取设备列表（非厂商下）
export const deviceLists = (params: any) => {
	return https().request(`robohub/device-list`, Method.POST, params, ContentType.json)
}
// 新增设备（非厂商下）
export const adddevicess = (params: any) => {
	return https().request(`robohub/add-device`, Method.POST, params, ContentType.json)
}
// 删除设备（非产商下）
export const deleteDevices = (params: any) => {
	return https().request(`robohub/delete-device`, Method.POST, params, ContentType.json)
}
// 编辑设备（非厂商下
export const editDevices = (params: any) => {
	return https().request(`robohub/edit-device`, Method.POST, params, ContentType.json)
}
// 获取产品设备列表 robohub/typeList?page=1&pageSize=100&vendorId=2
export const typeLists = (params: any) => {
	return https().request(`robohub/typeList?page=1&pageSize=100&vendorId=${params.ids}`, Method.GET, params, ContentType.json)
}
// 新增产品设备列表
export const addTypes = (params: any) => {
	return https().request(`robohub/addType`, Method.POST, params, ContentType.json)
}
// 删除产品设备 
export const deleteTypes = (params: any) => {
	return https().request(`robohub/deleteType?id=${params.id}`, Method.GET, params, ContentType.json)
}
// 编辑产品设备 robohub/updateType
export const updateTypes = (params: any) => {
	return https().request(`robohub/updateType`, Method.POST, params, ContentType.json)
}
// 设备序列号查询
// robohub/deviceSn-list
export const deviceSnlists = (params: any) => {
	return https().request(`robohub/deviceSn-list`, Method.GET, params, ContentType.json)
}
// 获取厂商下的设备号关联级别
export const venderAndDeviceTypeslist = (params: any) => {
	return https().request(`robohub/venderAndDeviceType-list`, Method.GET, params, ContentType.json)
}